import React from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import logo from "../../assets/raerLogo.png";
import { newcolor } from "../../constants/color";

const Footer = () => {
  return (
    <div className="footer-main">
      <div className="container-fluid footer-container">
        {/* heading text */}
        <div
          class="row p-4 text-center text-white footer-heading"
          style={{
            //  background: "#332C1F"
            background: newcolor.background,
          }}
        >
          <h4>
            “ Whatever the activity, the desire to improve is the purest path to
            satisfaction. “
          </h4>
        </div>

        {/* footer main container */}
        <div className="row footer-row">
          {/* Footer left container*/}
          <div className="col-lg-4 col-md-12  left-footer">
            {/* Navbar Logo */}
            <a class="navbar-brand" href="/">
              <img
                src={logo}
                alt=""
                width="80"
                height="60"
                class="d-inline-block align-text-top mt-3"
              />
            </a>

            {/* Contact Info */}
            <div class="row mt-3 contact-container">
              {/* <div class="d-flex gap-3">
                <i class="bi bi-geo-alt fs-4"></i>
                <p>381, M.G Road, Gorakund, Indore, Madhya Pradesh, 452001.</p>
              </div> */}

              <div class="d-flex align-items-center gap-2 mail-container">
                <i class="bi bi-envelope-at fs-5"></i>
                <p className="m-0">
                  <a href="mailto:Raerofficialclothing@gmail.com">
                    Raerofficialclothing@gmail.com
                  </a>
                </p>
              </div>

              {/* mobile number */}
              {/* <div class="d-flex gap-3">
                <i class="bi bi-telephone-plus fs-4"></i>
                <p>9981914176</p>
              </div> */}
            </div>

            {/* Follow Us */}
            <div class="row mt-5 follow-us-container">
              <h4>Follow Us</h4>

              <div className="social-icons-container">
                <a
                  href="https://www.facebook.com/profile.php?id=61555822198083"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="bi bi-facebook fs-3 me-3 social-icon"></i>
                </a>
                <a
                  href="https://www.instagram.com/raerofficialclothing?igsh=MTY0ZHZ5MTBhNHRmdw=="
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-instagram fs-3 me-3 social-icon text-danger"></i>
                </a>
              </div>
            </div>

            {/* Copyright */}
            <p
              className="fw-bold mt-5 copyright-container"
              style={{ fontSize: "14px" }}
            >
              © 2024
              <a
                href="https://www.ehawkers.co.in/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                E-HAWKERS MARKETING
              </a>
              . All rights reserved.
            </p>

            {/* <p style={{ opacity: "0.2" }}>@E-hawker marketting</p> */}
          </div>

          {/* Footer right container*/}
          <div
            className=" right-footer col-lg-8 col-md-12"
            // style={{ background: "#D6CFC1" }}
          >
            <div className="main-gmail mt-3">
              {/* <h2 class="">RECIEVE EMAIL UPDATES</h2> */}

              {/* <div class="gmail mt-3 mb-3">
                <input
                  type="text"
                  placeholder="Enter your email"
                  className=""
                />
                <button
                  class="text-white fs-5 "
                  style={{
                    backgroundColor: "#3E3232",
                    border: "none",
                  }}
                >
                  Send
                </button>
              </div> */}
            </div>

            <table className="table">
              <thead className="thead">
                <tr>
                  <th scope="col" className="fw-bold fs-5">
                    About
                  </th>

                  <th scope="col" className="fw-bold fs-5">
                    Help & Support
                  </th>

                  <th scope="col" className="fw-bold fs-5">
                    Join Us
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    {" "}
                    <a
                      class="nav-link active"
                      // aria-current="page"
                      href="/"
                      onClick={() => {
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      Home
                    </a>{" "}
                  </td>
                  <td>
                    <a
                      class="nav-link active"
                      href="/contact"
                      target="_blank"
                      onClick={() => {
                        window.scroll({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      Contact Us
                    </a>
                  </td>
                  <td>
                    <a
                      class="nav-link "
                      href="/about"
                      target="_blank"
                      onClick={() => {
                        window.scroll({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      About Raer
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a
                      class="nav-link "
                      href="/shop/allProduct"
                      // target="_blank"
                      onClick={() => {
                        window.scroll({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      Shop
                    </a>
                  </td>
                  <td>
                    <a
                      class="nav-link "
                      href="/return-and-refund-policy"
                      target="_blank"
                      onClick={() => {
                        window.scroll({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      Refund Policy
                    </a>
                  </td>
                  <td>
                    <a
                      class="nav-link "
                      href="/terms-and-conditions"
                      target="_blank"
                      onClick={() => {
                        window.scroll({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      Terms & Conditions
                    </a>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <a
                      class="nav-link "
                      href="/myaccount"
                      target="_blank"
                      onClick={() => {
                        window.scroll({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      Track Order
                    </a>
                  </td>
                  <td>
                    <a
                      class="nav-link "
                      href="/privacy-policy"
                      target="_blank"
                      onClick={() => {
                        window.scroll({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      Privacy policy
                    </a>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <a
                      class="nav-link "
                      href="/FAQ"
                      target="_blank"
                      onClick={() => {
                        window.scroll({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      FAQs
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
